
import {Component, Vue} from 'vue-property-decorator';

@Component({
  components: {}
})
export default class VersionUpdatedNotificationBar extends Vue {

  get isNewVersionAvailable() {
    return this.$version.isChanged
  }

  reload() {
    window.location.reload()
  }
}
